;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"03f807e2392dd745c32b6060d0c2365e96cd77e2"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs'
import { ROUTE_CHANGE_ABORTED_ERROR_NAME } from './src/common/hooks/useUnsavedChangesWarning'
import { version } from './package.json'

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN
const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT

Sentry.init({
  dsn: SENTRY_DSN,
  release: `v${version}`,
  environment: ENVIRONMENT,
  maxValueLength: 2000,
  enabled: ENVIRONMENT === 'prod',
  beforeSend(event) {
    if (
      event.exception?.values?.some(
        exception => exception.type === ROUTE_CHANGE_ABORTED_ERROR_NAME,
      )
    ) {
      return null
    }
    return event
  },
})

Sentry.setTag('side', 'server')
